import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageCircle, ChevronLeft, ChevronRight, Star } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
type Testimonial = {
  avatarLetter: string;
  message: string;
  time: string;
  name: string;
  planBadge: string;
};
const getTestimonials = (lang: 'es' | 'en'): Testimonial[] => [{
  avatarLetter: 'M',
  message: lang === 'es' ? 'Annysol acabo de recibir los documentos de mi LLC 🙌 no puedo creer lo rápido que fue todo. Gracias por explicarme cada paso, de verdad no esperaba que fuera tan sencillo 😭✨' : "Annysol I just received my LLC documents 🙌 I can't believe how fast it was. Thank you for explaining every step, I really didn't expect it to be this easy 😭✨",
  time: '9:47 AM',
  name: 'María G. 🇨🇴',
  planBadge: 'Plan 1'
}, {
  avatarLetter: 'C',
  message: lang === 'es' ? 'Llevo meses queriendo hacer esto y siempre lo dejaba para después porque me parecía muy complicado. Con Inkova lo hice en una semana. Ya tengo mi empresa y mi página lista para recibir clientes 🔥' : "I've been wanting to do this for months and kept putting it off because it seemed too complicated. With Inkova I did it in a week. I already have my company and website ready for clients 🔥",
  time: '2:13 PM',
  name: 'Carlos M. 🇲🇽',
  planBadge: 'Plan 3'
}, {
  avatarLetter: 'D',
  message: lang === 'es' ? 'Gracias!! La landing quedó exactamente como yo la tenía en mi cabeza pero mejor 😂 ya la compartí y varios me escribieron preguntando por mis servicios.' : 'Thank you!! The landing page turned out exactly how I had it in my head but better 😂 I already shared it and several people messaged me asking about my services.',
  time: '11:28 AM',
  name: 'Daniela R. 🇻🇪',
  planBadge: 'Plan 2'
}, {
  avatarLetter: 'P',
  message: lang === 'es' ? 'Oye de verdad gracias por tu paciencia. Tenía mil preguntas y tú siempre respondiste todo sin hacerme sentir perdida. Ya me siento con más confianza para vender 💜' : 'Hey really thank you for your patience. I had a thousand questions and you always answered everything without making me feel lost. I feel much more confident to sell now 💜',
  time: '4:52 PM',
  name: 'Patricia L. 🇵🇪',
  planBadge: 'Plan 3'
}];
const INKOVA_LOGO = 'https://cdn.magicpatterns.com/uploads/5dNkMTdHn2db35CcBKtHQx/INK_2.png';
function TestimonialCard({
  t,
  i
}: {
  t: Testimonial;
  i: number;
}) {
  const [logoError, setLogoError] = useState(false);
  const {
    lang
  } = useLanguage();
  return <div className="overflow-hidden testimonial-card flex flex-col h-full" style={{
    background: '#FFFFFF',
    border: '1px solid rgba(90,69,121,0.1)',
    borderRadius: '16px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
  }} data-id="element-561">
      {/* Header */}
      <div className="flex items-center wa-header" style={{
      background: '#f0f2f5',
      padding: '12px 16px',
      gap: '10px'
    }} data-id="element-562">
        {!logoError ? <img src={INKOVA_LOGO} alt="Inkova Creation" onError={() => setLogoError(true)} style={{
        width: '38px',
        height: '38px',
        borderRadius: '50%',
        objectFit: 'cover',
        background: '#5a4579',
        flexShrink: 0
      }} data-id="element-563" /> : <div className="flex items-center justify-center flex-shrink-0" style={{
        width: '38px',
        height: '38px',
        borderRadius: '50%',
        background: '#5a4579',
        color: '#FFFFFF',
        fontSize: '13px',
        fontWeight: 700
      }} data-id="element-564">
            ik.
          </div>}
        <div className="flex-grow leading-tight" data-id="element-565">
          <div style={{
          color: '#111B21',
          fontSize: '13px',
          fontWeight: 700
        }} data-id="element-566">
            Inkova Creation
          </div>
          <div className="flex items-center" style={{
          gap: '5px',
          marginTop: '1px'
        }} data-id="element-567">
            <span aria-hidden="true" style={{
            width: '7px',
            height: '7px',
            borderRadius: '50%',
            background: '#25D366',
            display: 'inline-block'
          }} data-id="element-568" />
            <span style={{
            color: '#25D366',
            fontSize: '11px'
          }} data-id="element-569">
              {lang === 'es' ? 'En línea' : 'Online'}
            </span>
          </div>
        </div>
        <Phone style={{
        color: '#7C3AED'
      }} size={18} strokeWidth={1.5} data-id="element-570" />
      </div>

      {/* Chat area */}
      <div className="wa-chat flex-grow" style={{
      background: '#f0f2f5',
      padding: '16px 12px'
    }} data-id="element-571">
        <div className="relative inline-block" style={{
        background: '#FFFFFF',
        borderRadius: '4px 16px 16px 16px',
        padding: '10px 14px',
        maxWidth: '88%',
        boxShadow: '0 1px 4px rgba(0,0,0,0.08)'
      }} data-id="element-572">
          <p className="wa-msg-text" style={{
          color: '#111B21',
          fontSize: '14px',
          lineHeight: 1.6,
          margin: 0
        }} data-id="element-573">
            {t.message}
          </p>
          <div className="flex justify-end items-center" style={{
          gap: '4px',
          marginTop: '6px'
        }} data-id="element-574">
            <span style={{
            color: '#8696A0',
            fontSize: '12px'
          }} data-id="element-575">
              {t.time}
            </span>
            <span style={{
            color: '#8696A0',
            fontSize: '12px',
            letterSpacing: '-2px'
          }} aria-label="Visto" data-id="element-576">
              ✓✓
            </span>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="flex items-center wa-footer" style={{
      background: '#FFFFFF',
      padding: '10px 16px',
      borderTop: '1px solid #f0f2f5',
      gap: '10px'
    }} data-id="element-577">
        <div className="flex items-center justify-center flex-shrink-0" style={{
        width: '28px',
        height: '28px',
        borderRadius: '50%',
        background: '#5a4579',
        color: '#FFFFFF',
        fontSize: '11px',
        fontWeight: 700,
        lineHeight: '28px',
        textAlign: 'center'
      }} data-id="element-578">
          {t.avatarLetter}
        </div>
        <div className="leading-tight" data-id="element-579">
          <div style={{
          color: '#111B21',
          fontSize: '14px',
          fontWeight: 700
        }} data-id="element-580">
            {t.name}
          </div>
          <div style={{
          color: '#8696A0',
          fontSize: '11px'
        }} data-id="element-581">
            {lang === 'es' ? 'Cliente verificado' : 'Verified client'}
          </div>
        </div>
        <span className="ml-auto" style={{
        background: '#EDE9FE',
        color: '#7C3AED',
        fontSize: '11px',
        fontWeight: 700,
        padding: '3px 10px',
        borderRadius: '20px'
      }} data-id="element-582">
          {t.planBadge}
        </span>
      </div>
    </div>;
}
function GoogleG() {
  return <svg width="20" height="20" viewBox="0 0 48 48" aria-hidden="true" data-id="element-583">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" data-id="element-584" />
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" data-id="element-585" />
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" data-id="element-586" />
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" data-id="element-587" />
    </svg>;
}
function GoogleRatingBanner() {
  const {
    lang
  } = useLanguage();
  return <motion.div initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="flex flex-col sm:flex-row items-center mx-auto" style={{
    background: '#FFFFFF',
    border: '1px solid #E5E7EB',
    borderRadius: '12px',
    padding: '16px 24px',
    maxWidth: '500px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    marginTop: '32px',
    gap: '14px'
  }} data-id="element-588">
      {/* Left */}
      <div className="flex items-center" style={{
      gap: '8px'
    }} data-id="element-589">
        <GoogleG data-id="element-590" />
        <span style={{
        color: '#111827',
        fontSize: '14px',
        fontWeight: 700
      }} data-id="element-591">
          Google Reviews
        </span>
      </div>

      {/* Middle */}
      <div className="flex items-center flex-wrap justify-center" style={{
      gap: '8px',
      flexGrow: 1,
      justifyContent: 'center'
    }} data-id="element-592">
        <span className="flex items-center" style={{
        gap: '1px'
      }} data-id="element-593">
          {Array.from({
          length: 5
        }).map((_, i) => <Star key={i} size={16} fill="#FBBF24" color="#FBBF24" data-id="element-594" />)}
        </span>
        <span style={{
        color: '#111827',
        fontSize: '16px',
        fontWeight: 700
      }} data-id="element-595">
          5.0
        </span>
        <span style={{
        color: '#6B7280',
        fontSize: '13px'
      }} data-id="element-596">
          {lang === 'es' ? '· 4 reseñas verificadas' : '· 4 verified reviews'}
        </span>
      </div>

      {/* Right */}
      <a href="https://maps.app.goo.gl/pp5UwdUTaXKUjQ8B8" target="_blank" rel="noopener noreferrer" className="hover:underline" style={{
      color: '#7C3AED',
      fontSize: '13px',
      fontWeight: 600,
      whiteSpace: 'nowrap'
    }} data-id="element-597">
        {lang === 'es' ? 'Ver reseñas →' : 'See reviews →'}
      </a>
    </motion.div>;
}
export function WhatsAppTestimonialsSection() {
  const {
    lang
  } = useLanguage();
  const testimonials = getTestimonials(lang);
  const total = testimonials.length;
  const [itemsPerView, setItemsPerView] = useState(2);
  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(false);
  // Responsive items per view
  useEffect(() => {
    const update = () => {
      setItemsPerView(window.innerWidth >= 768 ? 2 : 1);
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);
  // Clamp current when itemsPerView changes
  useEffect(() => {
    setCurrent(c => c % total);
  }, [itemsPerView, total]);
  const next = () => setCurrent(c => (c + 1) % total);
  const prev = () => setCurrent(c => (c - 1 + total) % total);
  // Autoplay
  useEffect(() => {
    if (paused) return;
    const id = setInterval(() => {
      setCurrent(c => (c + 1) % total);
    }, 4000);
    return () => clearInterval(id);
  }, [paused, total]);
  const slidePct = 100 / itemsPerView;
  const translate = current * slidePct;
  return <section className="wa-section" style={{
    background: '#F9FAFB',
    padding: '80px 20px'
  }} data-id="element-598">
      <style data-id="element-599">{`
        @media (min-width: 769px) {
          .wa-section { padding: 80px 40px !important; }
        }
      `}</style>

      <div style={{
      maxWidth: '1100px',
      margin: '0 auto'
    }} data-id="element-600">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14" data-id="element-601">
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} style={{
          color: '#5a4579',
          fontSize: '11px',
          fontWeight: 700,
          letterSpacing: '2px',
          textTransform: 'uppercase',
          textAlign: 'center'
        }} data-id="element-602">
            {lang === 'es' ? 'Así nos escriben' : 'How they write to us'}
          </motion.p>
          <motion.h2 initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.05
        }} className="text-[24px] md:text-[36px] flex items-center justify-center" style={{
          color: '#2D1B4E',
          fontWeight: 800,
          textAlign: 'center',
          marginTop: '8px',
          lineHeight: 1.2,
          gap: '12px',
          flexWrap: 'wrap'
        }} data-id="element-603">
            <span className="flex items-center justify-center flex-shrink-0" style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            background: 'rgba(37,211,102,0.12)'
          }} data-id="element-604">
              <MessageCircle size={22} strokeWidth={2.2} color="#25D366" data-id="element-605" />
            </span>
            {lang === 'es' ? 'Resultados que hablan por sí solos' : 'Results that speak for themselves'}
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-[14px] md:text-[16px]" style={{
          color: '#6B7280',
          textAlign: 'center',
          maxWidth: '500px',
          margin: '12px auto 0',
          lineHeight: 1.6
        }} data-id="element-606">
            {lang === 'es' ? 'Mensajes reales de clientes reales' : 'Real messages from real clients'}
          </motion.p>
        </div>

        {/* Carousel */}
        <div className="relative mx-auto" style={{
        maxWidth: '900px',
        padding: '0 40px'
      }} onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} data-id="element-607">
          {/* Prev arrow */}
          <button onClick={prev} aria-label={lang === 'es' ? 'Anterior' : 'Previous'} className="absolute top-1/2 -translate-y-1/2 left-0 flex items-center justify-center" style={{
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          background: '#FFFFFF',
          boxShadow: '0 2px 10px rgba(0,0,0,0.12)',
          border: 'none',
          cursor: 'pointer',
          zIndex: 2
        }} data-id="element-608">
            <ChevronLeft size={20} color="#1E1245" strokeWidth={2.4} data-id="element-609" />
          </button>

          {/* Next arrow */}
          <button onClick={next} aria-label={lang === 'es' ? 'Siguiente' : 'Next'} className="absolute top-1/2 -translate-y-1/2 right-0 flex items-center justify-center" style={{
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          background: '#FFFFFF',
          boxShadow: '0 2px 10px rgba(0,0,0,0.12)',
          border: 'none',
          cursor: 'pointer',
          zIndex: 2
        }} data-id="element-610">
            <ChevronRight size={20} color="#1E1245" strokeWidth={2.4} data-id="element-611" />
          </button>

          {/* Track viewport */}
          <div style={{
          overflow: 'hidden'
        }} data-id="element-612">
            <div className="flex items-stretch" style={{
            transform: `translateX(-${translate}%)`,
            transition: 'transform 0.5s ease'
          }} data-id="element-613">
              {testimonials.map((t, i) => <div key={i} className="flex-shrink-0" style={{
              width: `${slidePct}%`,
              padding: '0 10px',
              boxSizing: 'border-box'
            }} data-id="element-614">
                  <TestimonialCard t={t} i={i} data-id="element-615" />
                </div>)}
            </div>
          </div>
        </div>

        {/* Dots */}
        <div className="flex items-center justify-center" style={{
        gap: '6px',
        marginTop: '20px'
      }} data-id="element-616">
          {testimonials.map((_, i) => <button key={i} onClick={() => setCurrent(i)} aria-label={`${lang === 'es' ? 'Ir al testimonio' : 'Go to testimonial'} ${i + 1}`} style={{
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          border: 'none',
          padding: 0,
          cursor: 'pointer',
          background: i === current ? '#7C3AED' : '#E5E7EB',
          transition: 'background 0.2s ease'
        }} data-id="element-617" />)}
        </div>

        {/* Google rating banner */}
        <GoogleRatingBanner data-id="element-618" />

        {/* Verified note */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} style={{
        color: '#9CA3AF',
        fontSize: '12px',
        textAlign: 'center',
        marginTop: '32px'
      }} data-id="element-619">
          {lang === 'es' ? '✓ Mensajes verificados de clientes reales' : '✓ Verified messages from real clients'}
        </motion.p>
      </div>
    </section>;
}